export const enum SidebarButtonType {
  profile = 'Profile',
  notes = 'Notes',
  refer = 'Refer',
  scheduling = 'Scheduling'
}